import { Injectable, NgModule } from '@angular/core';
import {
  Translation,
  TranslocoLoader,
  TRANSLOCO_CONFIG,
  TranslocoConfig,
  TRANSLOCO_LOADER,
  TranslocoModule
} from '@ngneat/transloco';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  constructor(private http: HttpClient) {}

  getTranslation(lang: string) {
    return this.http.get<Translation>(`./assets/i18n/${lang}.json`);
  }
}

export const translocoConfig: TranslocoConfig = {
  availableLangs: ['en', 'fr'],
  defaultLang: 'en',
  fallbackLang: 'en',
  prodMode: environment.MSPOS_IS_DEPLOYED_BUILD,
  reRenderOnLangChange: true,
  missingHandler: {
    useFallbackTranslation: true
  }
};

@NgModule({
  exports: [TranslocoModule],
  providers: [
    {
      provide: TRANSLOCO_CONFIG,
      useValue: translocoConfig
    },
    {
      provide: TRANSLOCO_LOADER,
      useClass: TranslocoHttpLoader
    }
  ]
})
export class TranslocoRootModule {}
